import { saveAs } from 'file-saver'
import { useDispatch } from 'react-redux'

//UI
import { NonFormUpload } from '@/components/Elements'
import { Button, Flex, Heading, HStack, Spacer } from '@chakra-ui/react'
import { toast } from 'react-toastify'

//Hook
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'

//Helper
import { createExcelBlob } from '@/utils/fileHelper'
import { useCallback } from 'react'
import useECCN from '../../useECCN'

const ECCNListHeader = ({ title, handleAdd, query }) => {
  //Hooks
  const dispatch = useDispatch()
  const { useFetchAllECCNs, useUploadECCNs } = useECCN()

  const { data: allECCNsResponse } = useFetchAllECCNs({
    ...query,
    page: 1,
    pageSize: 0,
  })

  const uploadECCNs = useUploadECCNs()

  const handleUpload = async (file) => {
    if (!file) {
      toast.error('No File Uploaded')
      return
    }

    try {
      dispatch(showLoadingOverlay())
      await uploadECCNs.mutateAsync(file)
    } catch (error) {
      console.error(error)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  const handleDownloadAll = useCallback(() => {
    if (!allECCNsResponse?.data) {
      return
    }
    try {
      let excelData = []
      if (allECCNsResponse.data.length === 0) {
        excelData = [
          {
            country: '',
            code: '',
            description: '',
            status: '',
          },
        ]
      } else {
        excelData = allECCNsResponse.data.map((row) => {
          return {
            country: row.country,
            code: row.code,
            description: row.description,
            status: row.isDeleted ? 'inactive' : 'active',
          }
        })
      }

      const excelBlob = createExcelBlob(excelData)
      saveAs(excelBlob, `${title}.xlsx`)
    } catch (err) {
      console.log(err)
    }
  }, [allECCNsResponse?.data, title])

  return (
    <>
      <Flex p={5} borderBottom="1px solid #d8dbe0">
        <Heading>{title}</Heading>
        <HStack mx="5">
          <Button colorScheme="gray" onClick={handleDownloadAll}>
            Download
          </Button>
          <NonFormUpload uploadHandler={handleUpload} />
        </HStack>
        <Spacer />
        <Button colorScheme="blue" onClick={handleAdd}>
          Add {title}
        </Button>
      </Flex>
    </>
  )
}

export default ECCNListHeader
